<template>
  <div class="block">
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="deliveryData"
      dateField="DepartureDate"
      numberField="LogisticsNumber"
    />

    <kst-output field="ClientID" :data="deliveryData" :catalog="Catalog">
      <template #left>
        <kst-output addons floating-label
          field="ClientAlias" :data="deliveryData" :catalog="Catalog"
        />
      </template>
      <template #default>
        <kst-output addons expanded floating-label
          field="Client" :data="deliveryData" :catalog="Catalog"
        />
      </template>
    </kst-output>

    <kst-output field="VehicleIDNumber" :data="deliveryData" :catalog="Catalog"/>
    <kst-output field="Destination" :data="deliveryData" :catalog="Catalog"/>
    <kst-output field="ShipmentFee" :data="deliveryData" :catalog="Catalog"/>
    <kst-output field="ArrivalDate" :data="deliveryData" :catalog="Catalog"/>
    <kst-output field="CompletedDate" :data="deliveryData" :catalog="Catalog"/>
    <kst-output field="Comment" :data="deliveryData" :catalog="Catalog"/>
    <kst-output field="Status" :data="deliveryData" :catalog="Catalog"/>
    <kst-created :data="deliveryData"/>
    <kst-last-updated :data="deliveryData"/>
    <kst-output field="WarehouseID" :data="deliveryData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../DlvCatalog.js";

export default {
  props: {
    deliveryData: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>